import { useState, useContext, useEffect } from "react"
import { CustomButton } from "../components/global/CustomButton"
import { UserContext } from "../contexts/UserContext"
import { handleUpdateArray } from "../functions/UpdateUser"
import { NotificationRender } from "../components/global/NotificationRender"
import "./profile.css"

export function Profile() {
    const [profilePicture, setProfilePicture] = useState(null)
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [address, setAddress] = useState("")
    const [phone, setPhone] = useState("")
    const [currentPassword, setCurrentPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmNewPassword, setConfirmNewPassword] = useState("")

    const userDataContext = useContext(UserContext)
    const { user, notification } = userDataContext

    const handleFile = async (e) => {
        const file = e.target.files[0]
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
            const result = fileReader.result
            setProfilePicture(result)
        }
    }

    useEffect(() => {
        if (user) {
            setProfilePicture(user.profilePicture)
            setFirstName(user.firstName)
            setLastName(user.lastName)
            setEmail(user.email)
            setAddress(user.address)
            setPhone(user.phone)
        }
    }, [user])

    function handleUpdateUser() {
        const updatePayload = { firstName, lastName, email, address, phone, profilePicture }
        const reqBody = { ...updatePayload, currentPassword, newPassword, confirmNewPassword }
        handleUpdateArray(reqBody, "UPDATE_PROFILE", updatePayload, userDataContext)
    }

    return (
        <div className="account-form">

            {
                notification && notification.type.includes("PROFILE") &&
                    <NotificationRender notification={notification} />
            }

            <h4 className="primary-text">Edit Your Profile</h4>

            <div className="d-flex flex-column gap-3 cntr my-5 pic">
                <div className="profile-picture">
                    <img
                        src={profilePicture}
                        width={100}
                        height={100}
                        className="rounded-circle border"
                        alt=""
                    />
                </div>

                <div className={user && user.accountType === "google" ? "d-none" : "mt-4"}>
                    <input
                        type="file"
                        name="file"
                        id="file-input"
                        className="d-none"
                        onChange={handleFile}
                    />
                    <label htmlFor="file-input" className="profile-pic-label">
                        <div className="custom-btn default rounded-1">
                            {
                                user && user.profilePicture ?
                                    "Edit Profile Picture"
                                    :
                                    "Add Profile Picture"
                            }
                        </div>
                    </label>
                </div>

            </div>

            <div className="d-flex justify-content-between user-details mt-3 lg-row">
                <div className="">
                    <div>First Name</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        disabled={user && user.accountType === "google" ? true : false}
                    />
                </div>
                <div className="lastname-adress">
                    <div>Last Name</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        disabled={user && user.accountType === "google" ? true : false}
                    />
                </div>
            </div>

            <div className="d-flex flex-wrap justify-content-between user-details my-4 lg-row">
                <div>
                    <div>Email</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={user && user.accountType === "google" ? true : false}
                    />
                </div>
                <div className="lastname-adress">
                    <div>Address</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="Your address"
                    />
                </div>

            </div>

            <div className="d-flex flex-wrap justify-content-between user-details my-4">
                <div className="">
                    <div>Phone</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Your phone number"
                    />
                </div>
                <div className="border d-none">
                </div>
            </div>

            <div>
                <div>Password Changes</div>
                <input
                    type="text"
                    className="w-100 mt-2 custom-input"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    placeholder="Current Password"
                    disabled={user && user.accountType === "google" ? true : false}
                />
                <br />
                <input
                    type="text"
                    className="w-100 my-3 custom-input"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="New Password"
                    disabled={user && user.accountType === "google" ? true : false}
                />
                <br />
                <input
                    type="text"
                    className="w-100 custom-input"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    placeholder="Confirm New Password"
                    disabled={user && user.accountType === "google" ? true : false}
                />
            </div>

            <div className="d-flex justify-content-end gap-3 mt-3 buttons-section">
                <CustomButton
                    color="default"
                    text="Cancel"
                />
                <CustomButton
                    color="primary"
                    text="Save Changes"
                    btnFunction={handleUpdateUser}
                />
            </div>

        </div>
    )
}